export default __webpack_public_path__ + "static/iot-c7cd457cb7f95289d3d318b30e262759.png";